import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import {  
  Autocomplete,
  Popover,
  Button,
  Stack,
  TextField,
  Container
} from '@mui/material';

// Calendario
import { DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt-BR'; 


import { getUsuarios, getClientes, getFluxogramas, getUsuariosMontador } from './api';

import config from '../config.json';


// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroChamados = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro)
  const status = ['Pendente', 'Aprovado', 'Rejeitado'];
  const tiposolicitacao = [1,2] // 1 para desconto 2 para alocaocao orcamento


  // Calendario
  // Calendario 1 (Data Inicial)
  const [openCalendar1, setOpenCalendar1] = useState(false);
  const handleCalendarOpen1 = () => {
    setOpenCalendar1(true);
  };
  const handleCalendarClose1 = () => {
    setOpenCalendar1(false);
  };
  const handleDateChange1 = (date) => {
    setFiltro({ ...filtro, datainicial: date });
    handleCalendarClose1(); // Feche o calendário após a seleção da data
  };

  // Calendario 2 (Data Final)
  const [openCalendar2, setOpenCalendar2] = useState(false);
  const handleCalendarOpen2 = () => {
    setOpenCalendar2(true);
  };
  const handleCalendarClose2 = () => {
    setOpenCalendar2(false);
  };
  const handleDateChange2 = (date) => {
    setFiltro({ ...filtro, datafinal: date });
    handleCalendarClose2(); // Feche o calendário após a seleção da data
  };
  // Calendario

  const handleConfirm = () => {
    props.onConfirm(filtro)
  }  
  return (


    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{height: 'auto'}}>
        <Stack direction={'row'} gap={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar1}
              onOpen={ handleCalendarOpen1}
              onClose={handleCalendarClose1}
              value={filtro.datainicial}
              onChange={handleDateChange1}
              renderInput={(params) => <TextField {...params} label='Data Inicial' />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar2}
              onOpen={handleCalendarOpen2}
              onClose={handleCalendarClose2}
              value={filtro.datafinal}
              onChange={handleDateChange2}
              renderInput={(params) => <TextField {...params} label='Data Final' />}
            />
          </LocalizationProvider>
        </Stack>

        <Autocomplete
          disablePortal
          id="tipo"
          value={filtro.tipo}
          onChange={(event, newValue) => {
            setFiltro({...filtro, tipo: newValue})
          }}
          options={tiposolicitacao}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => `${option === 1 ? 'Aplicação Desconto':'Orçamento Alocado'}`}
          renderInput={(params) => <TextField {...params} label="Tipo Solicitação" />}
        />

        <Autocomplete
          disablePortal
          id="status"
          value={filtro.status}
          onChange={(event, newValue) => {
            setFiltro({...filtro, status: newValue})
          }}
          options={status}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => `${option}`}
          renderInput={(params) => <TextField {...params} label="Status" />}
        />
        

        <Container sx={{marginTop: 2}}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
        
        

      </Stack>
      
    </Popover>
  );
})

PopoverFiltroChamados.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func
}

export default (PopoverFiltroChamados);